import styled from 'styled-components';

/** The row of files waiting above the composer while they upload. */

export const StagedRow = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  /* Only the margin separates the chips from the input now. The padding used to
     keep a classic scrollbar off them; the bar is hidden instead, since the row
     is short, scrolls by wheel and every chip has its own remove button. */
  margin-bottom: 8px;

  ::-webkit-scrollbar {
    height: 0;
  }
  scrollbar-width: none;
`;

export const Chip = styled.div<{ $failed?: boolean }>`
  position: relative;
  flex: none;
  width: 168px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 10px;
  background: ${({ theme }) => theme.gray};
  border: 1px solid
    ${({ theme, $failed }) => ($failed ? theme.primary : theme.mediumGray)};
  overflow: hidden;
`;

export const Thumb = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 6px;
  flex: none;
  overflow: hidden;
  background: ${({ theme }) => theme.white};
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Meta = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  line-height: 16px;

  span:first-child {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${({ theme }) => theme.darkGray};
  }

  span:last-child {
    color: ${({ theme }) => theme.lightGray};
  }
`;

export const RemoveButton = styled.button`
  margin-left: auto;
  flex: none;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  display: flex;
`;

/** Sits along the bottom edge of the chip while the file uploads. */
export const ProgressBar = styled.div<{ $value: number }>`
  position: absolute;
  left: 0;
  bottom: 0;
  height: 3px;
  width: ${({ $value }) => $value}%;
  background: ${({ theme }) => theme.primary};
  transition: width 0.2s ease;
`;

/** Hidden input the attach button drives. */
export const HiddenFileInput = styled.input`
  display: none;
`;
